import { CardNumberElement } from "@stripe/react-stripe-js";

import { Dispatch } from "common/types/redux";

import {
  createPaymentMethodFinished,
  createPaymentMethodStarted
} from "seneca-common/features/subscriptions/state";
import { logMessage } from "seneca-common/utils/sentry/logError";

import { handlePaymentMethodCreation } from "features/subscriptions/features/stripe/actions/handlePaymentMethodCreation";

import { Options } from "../types/HandleSourceCreationOptions";

export function handleCreditCardFormSubmit({
  subscriptionId,
  subscriptionProductId,
  cardHolderEmail,
  postcode,
  addonProductIds,
  options
}: {
  subscriptionId?: string;
  subscriptionProductId: string;
  cardHolderEmail?: string;
  postcode?: string;
  addonProductIds?: string[];
  options: Options;
}) {
  const { onStart, ...downStreamOptions } = options;
  const { stripe, stripeElements, onError } = downStreamOptions;
  return async function (dispatch: Dispatch) {
    dispatch(createPaymentMethodStarted());
    onStart && onStart();
    onError && onError(null);

    if (!stripe) {
      logMessage(
        "Unable to create stripe source as the stripe library has not loaded"
      );
      onError && onError("Sorry, something went wrong");
      return;
    }

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: stripeElements.getElement(CardNumberElement)!,
      billing_details: {
        address: {
          postal_code: postcode
        }
      }
    });

    if (error) {
      logMessage("Error received when attempting to create stripe source", {
        error
      } as any);
      onError && onError(error.message);
      return;
    }

    await dispatch(
      handlePaymentMethodCreation({
        subscriptionId,
        subscriptionProductId,
        stripePaymentMethodId: paymentMethod!.id,
        cardHolderEmail,
        addonProductIds,
        options: downStreamOptions
      })
    );

    dispatch(createPaymentMethodFinished());
  };
}
